<template>
  <div class="home">
    <CardLarge
      class="card center"
      @touchstart.native="onTouchStart"
      @touchmove.native="onTouchMove"
    >
      <img class="swipe-animation" src="images/swipe-animation.svg" />
      <div class="description" v-html="description" />
      <CTA :label="buttonLabel" :to="{ name: 'selectTheme' }" />
    </CardLarge>

    <div class="links">
      <a :href="privacy.link" target="_blank">{{ privacy.text }}</a>
      <a :href="faq.link" target="_blank">{{ faq.text }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { gsap } from "gsap";
import CTA from "@/components/UI/CTA.vue";
import CardLarge from "@/components/Layout/CardLarge.vue";

export default {
  name: "Home",

  components: {
    CTA,
    CardLarge,
  },

  data: () => ({
    touchstartX: 0,
    touchendX: 0,
    swipeDirection: null,
  }),

  computed: {
    ...mapState({
      description: (state) => state.dictionary.home.description,
      buttonLabel: (state) => state.dictionary.home.button,
      privacy: (state) => state.dictionary.general.privacy,
      faq: (state) => state.dictionary.general.faq,
    }),
  },

  methods: {
    onTouchStart(e) {
      this.touchstartX = e.changedTouches[0].screenX;
    },

    onTouchMove(e) {
      this.touchendX = e.changedTouches[0].screenX;
      this.checkDirection();
    },

    checkDirection() {
      const move = Math.abs(this.touchstartX - this.touchendX);
      if (move < 70) return;

      if (this.touchendX < this.touchstartX) this.swipeDirection = -1;
      if (this.touchendX > this.touchstartX) this.swipeDirection = 1;

      this.animateSwipe();
    },

    animateSwipe() {
      gsap.to(".card", {
        x: 100 * this.swipeDirection,
        opacity: 0,
        onComplete: () => this.animationComplete(),
      });
    },

    animationComplete() {
      this.$router.push({ name: "selectTheme" }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  text-align: center;
}

.links,
.card {
  margin-top: auto;
}

.description {
  color: $blue;
  max-width: 300px;
  margin: 0 auto;
  padding-bottom: 40px;
  @include type-large();

  @include media(">phone") {
    max-width: 430px;
  }
}

.cta {
  align-self: center;
}

.swipe-animation {
  display: none;
  pointer-events: none;
  height: 200px;
  width: auto;

  @media (hover: none) and (pointer: coarse) {
    display: block;
  }
}

.links {
  padding-top: 25px;

  a {
    color: white;
    text-decoration: none;
    @include type-small();
    font-weight: bold;
    margin: 0 10px;
  }
}
</style>
